module.exports = __webpack_public_path__ + "img/2.ed6ae9eb.jpg";